import { Component, OnInit } from "@angular/core";


import { Router } from "@angular/router";
import { Globals } from "./globals";
import { AutorizacionService } from "./autorizacion.service";
import Swal from "sweetalert2";
import { AngularFireAuth } from '@angular/fire/auth';
import * as firebase from "firebase";


@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"]
})
export class AppComponent {
  user: any;
  mostrarComponentes: boolean = false;

  constructor(
    private autorizacionService: AutorizacionService,

    private router: Router,
    public globals: Globals,
    private afAuth: AngularFireAuth
  ) {

  }

  ngOnInit() {
    console.log("ES AUTH",this.globals.EstaAuntenticado)
    this.mostrarComponentes = true;
    if(localStorage.getItem('tipoAuth') == "correo"){
      console.log(localStorage.getItem('tipoAuth'))
      let data = JSON.parse(localStorage.getItem('correo'))
      this.user = data




      this.autorizacionService.consultarDatosUsuario(data.correo).subscribe(datos => {
        console.log("USER",datos);

        try {
          //////conole.log(datos[0].correo_corporativo);
        }
        catch(err) {


          Swal.fire(
            "No te encuentras registrado en el modulo Compliance frontera, contacta con a el administrador"
          );

          this.signOut();


        }

        //////conole.log(this.globals.lenguaje);

        this.globals.CorreoUsuario = datos[0].correo_corporativo;
        this.globals.IdFuncionarioTablaFuncionarios = datos[0].idtbl_funcionario;
        this.globals.NombreCompletoUsuario = datos[0].nombre_completo;
        this.globals.SuperAdministrador = datos[0].super_admin;
        this.globals.IdSapFrontera = datos[0].idfronteraok;
        this.globals.lenguaje = datos[0].idioma.toLowerCase();

        this.globals.EstaAuntenticado = true;

        if (
          this.globals.lenguaje == "en" ||
          this.globals.lenguaje == "ingles"
        ) {
          this.globals.lenguaje = "en";
        } else {
          this.globals.lenguaje = "es";
        }


        this.mostrarComponentes = true;
       // this.router.navigate(["/inicio"]);


        switch (this.router.url) {
          case "/administradorconflictos":
            break;
          case "/administrar-usuario":
            if (this.globals.SuperAdministrador == "0") {
              Swal.fire(
                "No tienes permisos para usar el modulo de administracion de usuarios(Contacta con el administrador del sistema)"
              );

              this.signOut();
            }
            break;
          default:
            //////conole.log("default");
        }
      });

    } else {


    this.afAuth.authState.subscribe(user => {
  // this.authService.authState.subscribe(user => {
      // this.user = user;
       console.log(user)

       console.log(localStorage.getItem('tipoAuth'))
       let data = JSON.parse(localStorage.getItem('correo'))
       this.user = data

      if (user) {
        //////conole.log("logueado");
        this.globals.EstaAuntenticado = true;

        this.autorizacionService.consultarDatosUsuario(user.email).subscribe(datos => {
          //////conole.log(datos);

          try {
            //////conole.log(datos[0].correo_corporativo);
          }
          catch(err) {


            Swal.fire(
              "No te encuentras registrado en el modulo Compliance frontera, contacta con a el administrador"
            );

            this.signOut();


          }

          //////conole.log(this.globals.lenguaje);

          this.globals.CorreoUsuario = datos[0].correo_corporativo;
          this.globals.IdFuncionarioTablaFuncionarios = datos[0].idtbl_funcionario;
          this.globals.NombreCompletoUsuario = datos[0].nombre_completo;
          this.globals.SuperAdministrador = datos[0].super_admin;
          this.globals.IdSapFrontera = datos[0].idfronteraok;
          this.globals.lenguaje = datos[0].idioma.toLowerCase();

          if (
            this.globals.lenguaje == "en" ||
            this.globals.lenguaje == "ingles"
          ) {
            this.globals.lenguaje = "en";
          } else {
            this.globals.lenguaje = "es";
          }


          this.mostrarComponentes = true;





          switch (this.router.url) {
            case "/administradorconflictos":
              break;
            case "/administrar-usuario":
              if (this.globals.SuperAdministrador == "0") {
                Swal.fire(
                  "No tienes permisos para usar el modulo de administracion de usuarios(Contacta con el administrador del sistema)"
                );

                this.signOut();
              }
              break;
            default:
              //////conole.log("default");
          }
        });
      } else {
        //////conole.log("nologuedo");
        this.globals.EstaAuntenticado = false;
        this.globals.RutaDeRedireccion = this.router.url;
        this.router.navigate(["/login"]);
        this.globals.EstaAuntenticado = false;

        this.mostrarComponentes = true;
      }
    });
  }
}

  // signInWithGoogle(): void {
  //   this.authService.signIn(GoogleLoginProvider.PROVIDER_ID);

  // }

  loginWithMicrosoft() {

   const provider = new firebase.auth.OAuthProvider('microsoft.com')
   provider.setCustomParameters({
    tenant: '2637d50c-c560-436c-8997-ebe63c9656fd',
   })
   this.afAuth.auth.signInWithPopup(provider)
   localStorage.setItem('tipoAuth','ms')

  }

  signOut(): void {
   // this.authService.signOut();
   this.afAuth.auth.signOut()
   localStorage.removeItem('correo')
   localStorage.removeItem('tipoAuth')
   this.router.navigate(["/login"]);
   this.user = null
  }

  Es(): void {
    //////conole.log("Es");
    this.globals.lenguaje = "es";

    this.router.navigate(["/inicio"]);





  }

  En(): void {
    //////conole.log("En");
    this.globals.lenguaje = "en";

    this.router.navigate(["/inicio"]);

  }

  home(): void {
    //this.globals.contenedorVarGlobal = "";
    this.router.navigate(["/inicio"]);
  }

  IrAlogin() {
    this.router.navigate(["/login"]);
  }

  IrAdminusuarios() {
    this.router.navigate(["/administrar-usuario"]);
  }

  IrAdminConflictos() {
    this.router.navigate(["/administradorconflictos"]);
  }
}
